export enum FORM_NAME {
  CREATE_PARTNER = 'CREATE_PARTNER',
  UPDATE_PARTNER = 'UPDATE_PARTNER',
}
